import {
    Action,
    handleActions,
} from 'redux-actions';
import {
    Item,
    ItemPayload,
    QC_MEDIA_ITEM_RESET,
    QC_MEDIA_ITEM_SET,
} from './QCMediaActions';

export interface QCMediaState {
    item: Item | null;
}

export const setItem = (state: QCMediaState, {payload}: Action<ItemPayload>): QCMediaState => {
    const item = payload;
    
    if (item)
        return {
            item,
        };
    
    return state;
};

export const resetItem = (): QCMediaState => {
    return initialState;
};

export const initialState: QCMediaState = {
    item: null,
};

const handlers = {
    [QC_MEDIA_ITEM_SET]: setItem,
    [QC_MEDIA_ITEM_RESET]: resetItem,
};

export default handleActions<QCMediaState, ItemPayload>(handlers, initialState);
